webpackJsonp([581],{

/***/ 1062:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2016:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1062),
  /* template */
  __webpack_require__(2540),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/components_layout-39.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] components_layout-39.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1fdadbf0", Component.options)
  } else {
    hotAPI.reload("data-v-1fdadbf0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2540:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("layout")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Divider_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/divider/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/divider"
    }
  }, [_vm._v("进入demo页面")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/divider",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Divider.vue",
      "target": "_blank"
    }
  }, [_vm._v("demo源码")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Divider } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("\n不支持配置分割线颜色，因为线条是通过图片来实现的。好处是在任何背景颜色下都可以适应。如果需要配置颜色，请使用"), _c('a', {
    attrs: {
      "href": "#",
      "jump-to-id": "loadmore"
    }
  }, [_vm._v("`load-more`")]), _vm._v("组件。\n")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("我是有底线的"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("divider")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("分隔线标题")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/divider"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Grid_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/grid/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/grid"
    }
  }, [_vm._v("进入demo页面")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/grid",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Grid.vue",
      "target": "_blank"
    }
  }, [_vm._v("demo源码")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Grid, GridItem } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("grid")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("grid-item")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("label")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"Grid\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-for")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"i in 9\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("img")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"icon\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("src")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"../assets/grid_icon.png\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("grid-item")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("grid")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("Grid")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("rows")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.0")])]), _vm._v(" "), _c('td', [_vm._v("(v2.6.0 之后废弃，使用 col 替代)宫格行数，建议少于"), _c('code', [_vm._v("5")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("cols")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("3")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.6.1")])]), _vm._v(" "), _c('td', [_vm._v("列数。如果为非单行 Grid，需要设置 cols，否则所有 GridItem 会平均宽度显示在一行。")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-lr-borders")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('td', [_vm._v("是否显示左右边框")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("show-vertical-dividers")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.8.1")])]), _vm._v(" "), _c('td', [_vm._v("是否显示垂直分割线")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("用于"), _c('code', [_vm._v("grid-item")]), _vm._v("的插槽")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-component-name"
  }, [_vm._v("GridItem")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("图标地址，如果是线上地址，推荐使用该prop。如果是本地图标资源，使用"), _c('code', [_vm._v("slot=icon")]), _vm._v("可以保证资源被正确打包")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_c('code', [_vm._v("label")]), _vm._v(" 文字")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("link")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("vue-router 路径")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("icon")])]), _vm._v(" "), _c('td', [_vm._v("图标内容，直接使用"), _c('code', [_vm._v("<img>")]), _vm._v("标签")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("label")])]), _vm._v(" "), _c('td', [_vm._v("label 文字的 slot，作用同 prop:label")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/grid"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Scroller_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/scroller/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/scroller"
    }
  }, [_vm._v("进入demo页面")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/scroller",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Scroller.vue",
      "target": "_blank"
    }
  }, [_vm._v("demo源码")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Scroller } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n该组件已经不再维护，也不建议使用，大部分情况下也不需要用到该组件。\n"), _c('br'), _vm._v("\n建议使用第三方相关组件，相关 issue 将不会处理。\n")]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n`Scroller`的内容必须是一个`div`，并且只能有一个`div`\n"), _c('br'), _vm._v("\n`Scroller` 希望解决的是简单的列表问题而不是一个内嵌各种复杂标签交互的容器，很容易发生性能或者交互问题。\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n默认高度为整个视口高度，如果你加了`x-header`，那么你需要减去一个`x-header`的高度: `height=\"-46\"`\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n请确保在你的数据更新后进行`reset`操作(参考下面文档)，如果你做了`reset`还有问题再开`issue`并附上代码，否则将`绝对不会被处理`。\n")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("value")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("对象，上拉或者下拉的状态双向绑定，使用 v-model 绑定，pulldownStatus 及 pullupStatus")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("height")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("viewport height")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("容器高度，默认为整个viewport高度，注意，该属性接受的是 String 类型，比如 200px，如果你希望scroller自动计算除去头部尾部的高度，请这样设置让组件自动计算，如"), _c('code', [_vm._v("height=\"-40\"")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("lock-x")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("锁定X方向")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("lock-y")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("锁定Y方向")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollbar-x")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否显示横向滚动条")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollbarY")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否显示垂直方向滚动条")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bounce")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否显示边缘回弹效果")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("use-pulldown")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否使用下拉组件")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("use-pullup")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否使用上拉组件")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("pulldown-config")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("see below")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("下拉组件配置")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("pullup-config")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-object"
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("see below")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("上拉组件配置")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll-bottom-offset")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])]), _vm._v(" "), _c('td', [_vm._v("在距离底部多长距离时触发事件 on-scroll-bottom")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("scroller 内容，必须是一个 "), _c('code', [_vm._v("div")]), _vm._v(" 元素")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-scroll")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(position)")])]), _vm._v(" "), _c('td', [_vm._v("容器滚动时触发，参数为"), _c('code', [_vm._v("top")]), _vm._v("和"), _c('code', [_vm._v("left")]), _vm._v("位置")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-scroll-bottom")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("滚动到底部时触发，注意事件会触发多次，如果你需要进行数据获取，记得设置一个状态值")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.1-rc.6")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-pulldown-loading")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("用户触发下拉刷新状态，监听该事件以获取加载新数据")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-pullup-loading")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("用户触发上拉加载状态，监听该事件以加载新数据")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("reset")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(position, duration, easing)")])]), _vm._v(" "), _c('td', [_vm._v("在内容变化(v-for渲染，异步数据加载)后需要调用，用以重新渲染，避免新加的内容无法上拉看到，一般在 $nextTick 回调里调用。easing 可以为 ease-in, ease-in-out, ease, bezier(n, n, n, n)")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("donePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("设置上拉刷新操作完成，在数据加载后执行")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("disablePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("禁用上拉刷新，在没有更多数据时执行")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("enablePullup")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("启用上拉刷新插件")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("donePulldown")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("设置下拉刷新操作完成，在数据加载后执行")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/scroller"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('p', [_vm._v("pulldown 默认配置:")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Down To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("60")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("autoRefresh")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("downContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Down To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("upContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Release To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loadingContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Loading...'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("clsPrefix")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'xs-plugin-pulldown-'")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("pullup 默认配置:")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("{\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("content")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Up To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("pullUpHeight")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("60")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("height")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("40")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("autoRefresh")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-literal"
  }, [_vm._v("false")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("downContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Release To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("upContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Pull Up To Refresh'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("loadingContent")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'Loading...'")]), _vm._v(",\n  "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("clsPrefix")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'xs-plugin-pullup-'")]), _vm._v("\n}\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何更新数据")])]), _vm._v(" "), _c('p', [_vm._v("如果展示内容只是简单的增加或者减少，直接调用"), _c('code', [_vm._v("reset")]), _vm._v("方法即可")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$nextTick("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset()\n})\n")])]), _vm._v(" "), _c('p', [_vm._v("如果展示内容完全重载，那么需要主动设置位置让其能正确回到顶部。适用于改变筛选条件后重载数据的情况")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$nextTick("), _c('span', {
    staticClass: "hljs-function"
  }, [_c('span', {
    staticClass: "hljs-params"
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset({\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("top")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("0")]), _vm._v("\n  })\n})\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何设置pullup完成")])]), _vm._v(" "), _c('p', [_vm._v("方法1，直接调用ref的"), _c('code', [_vm._v("donePullup")]), _vm._v("方法")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.demo2.donePullup()\n")])]), _vm._v(" "), _c('p', [_vm._v("方法2，绑定value, 重置状态")]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("自定义pullup模板同样是用v-model来绑定以获取状态变化")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("scroller")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("v-model")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"status\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("scroller")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("data () {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("return")]), _vm._v(" {\n    "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("status")]), _vm._v(": {\n      "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("pullupStatus")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'default'")]), _vm._v("\n    }\n  }\n}\n")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("// 重置状态为default\nthis.status.pullupStatus = 'default\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何设置pulldown完成")])]), _vm._v(" "), _c('p', [_vm._v("参照"), _c('code', [_vm._v("pullup")]), _vm._v(", 使用方法"), _c('code', [_vm._v("donePulldown")]), _vm._v("或者绑定"), _c('code', [_vm._v("pulldownStatus")]), _vm._v("然后重置为"), _c('code', [_vm._v("default")]), _vm._v("。")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("QA 如何禁用或者启用pullup")])]), _vm._v(" "), _c('p', [_vm._v("在有些情况下，比如数据不多不需要上拉加载或者已经加载完成，我们需要禁用pullup"), _c('br'), _vm._v("\n同样可以调用方法 "), _c('code', [_vm._v("disablePullup")]), _vm._v(" 或者设置"), _c('code', [_vm._v("pullupStatus")]), _vm._v("为"), _c('code', [_vm._v("disabled")])]), _vm._v(" "), _c('p', [_vm._v("反之，则调用方法 "), _c('code', [_vm._v("enablePullup")]), _vm._v(" 或者设置"), _c('code', [_vm._v("pullupStatus")]), _vm._v("为"), _c('code', [_vm._v("enabled")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-qa"
  }, [_vm._v("启用keep-alive后滚动有问题")])]), _vm._v(" "), _c('p', [_vm._v("需要在调用Scroller的页面上在 hook: "), _c('code', [_vm._v("activated")]), _vm._v("上执行"), _c('code', [_vm._v("reset")])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("activated () {\n  "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("this")]), _vm._v(".$refs.scroller.reset()\n}\n")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("Sticky_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/sticky/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/sticky"
    }
  }, [_vm._v("进入demo页面")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/sticky",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/Sticky.vue",
      "target": "_blank"
    }
  }, [_vm._v("demo源码")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { Sticky } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "tip"
  }, [_vm._v("在Chrome模拟器运行时你可能会发现没有效果，这是因为Chrome并不支持原生sticky实现而模拟器环境是iPhone，目前程序是根据Safari版本来判断是否原生支持sticky。因此你可以切换到Android系统进行测试，但是真机上是完全正常的交互。\n"), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n你也可以设置禁用原生支持检测以获得相同的效果：`:check-sticky-support=\"false\"`\n")]), _vm._v(" "), _c('p', [_vm._v("如果你没有使用"), _c('code', [_vm._v("100%")]), _vm._v("的布局，也没有头部可以直接这样使用")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("sticky")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("Blabla"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("sticky")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("如果你像demo一样使用"), _c('code', [_vm._v("view-box")]), _vm._v("和"), _c('code', [_vm._v("x-header")]), _vm._v("，那么需要这样：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("sticky")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("scroll-box")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux_view_box_body\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":offset")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"46\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("Blabla"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("sticky")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("建议加一个"), _c('code', [_vm._v("div")]), _vm._v("高度为内容高度，这样可以避免当定位为"), _c('code', [_vm._v("sticky")]), _vm._v("时下面的元素会突然向上走。")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_vm._v("// 禁用原生检测时，可以在外围加\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"height:44px;\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("sticky")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("scroll-box")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux_view_box_body\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":offset")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"46\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":check-sticky-support")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"false\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("Blabla"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("sticky")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n\n// 使用原生检测时，`div`紧挨着组件之后，并设置类名`vux-sticky-fill`\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("sticky")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("scroll-box")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux_view_box_body\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v(":offset")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"46\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("Blabla"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("sticky")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("class")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"vux-sticky-fill\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"height:44px;\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', {
    staticClass: "warning"
  }, [_vm._v("\n请不要直接照抄 demo 代码，滚动容器为 window 时请不要指定 scroll-box，滚动容器并非使用 `view-box` 时 id 并不是 `vux_view_box_body`，请按照实际情况来设定。\n")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scroll-box")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("window")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("滚动容器，默认为"), _c('code', [_vm._v("window")]), _vm._v("，如果你使用了viewbox，那么你需要指定容器id："), _c('code', [_vm._v("vux_view_box_body")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("check-sticky-support")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否检测当前浏览器是否支持sticky特性，禁用则在"), _c('code', [_vm._v("iPhone")]), _vm._v("设置上也使用"), _c('code', [_vm._v("scroll")]), _vm._v("实现")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("offset")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-number"
  }, [_vm._v("Number")])]), _vm._v(" "), _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("距离顶部高度，在存在头部（如使用了"), _c('code', [_vm._v("x-header")]), _vm._v("）的情况下需要设置一个距离")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("内容插槽")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bindSticky")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("手动重新绑定，用于内容变化导致位置变化定位不再正确的情况")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.4")])])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/sticky"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("ViewBox_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/view-box/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/view-box"
    }
  }, [_vm._v("进入demo页面")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/view-box",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/ViewBox.vue",
      "target": "_blank"
    }
  }, [_vm._v("demo源码")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { ViewBox } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("该组件为"), _c('code', [_vm._v("100%高")]), _vm._v("布局，可以解决部分键盘输入的问题，但是同时会在safari中出现向下滚动时无法自动隐藏url工具栏和底部栏的问题。")]), _vm._v(" "), _c('p', [_vm._v("在"), _c('code', [_vm._v("viewBox")]), _vm._v("里元素定位为"), _c('code', [_vm._v("absolute")]), _vm._v("，效果等同于"), _c('code', [_vm._v("fixed")]), _vm._v("。")]), _vm._v(" "), _c('p', [_vm._v("使用时需要设置 html, body 高为100%:")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-selector-tag"
  }, [_vm._v("html")]), _vm._v(", "), _c('span', {
    staticClass: "hljs-selector-tag"
  }, [_vm._v("body")]), _vm._v(" {\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("height")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("100%")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("width")]), _vm._v(": "), _c('span', {
    staticClass: "hljs-number"
  }, [_vm._v("100%")]), _vm._v(";\n  "), _c('span', {
    staticClass: "hljs-attribute"
  }, [_vm._v("overflow-x")]), _vm._v(": hidden;\n}\n")])]), _vm._v(" "), _c('p', [_vm._v("view-box"), _c('code', [_vm._v("所有父div")]), _vm._v("也需要为100%高度：")]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"height:100%;\"")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("view-box")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("ref")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"viewBox\"")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-header")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"header\"")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("style")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"width:100%;position:absolute;left:0;top:0;z-index:100;\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("x-header")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("router-view")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("router-view")]), _vm._v(">")]), _vm._v("\n    "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("<"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("tabbar")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-attr"
  }, [_vm._v("slot")]), _vm._v("="), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("\"bottom\"")]), _vm._v(">")]), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("tabbar")]), _vm._v(">")]), _vm._v("\n  "), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("view-box")]), _vm._v(">")]), _vm._v("\n"), _c('span', {
    staticClass: "hljs-tag"
  }, [_vm._v("</"), _c('span', {
    staticClass: "hljs-name"
  }, [_vm._v("div")]), _vm._v(">")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_vm._v("如果你想保存滚动距离，推荐使用"), _c('code', [_vm._v("vuex")]), _vm._v("实现，在特定"), _c('code', [_vm._v("path")]), _vm._v("对"), _c('code', [_vm._v("scrollBody")]), _vm._v("监听"), _c('code', [_vm._v("scroll")]), _vm._v("事件，并获取滚动距离保存到"), _c('code', [_vm._v("vuex")]), _vm._v("的"), _c('code', [_vm._v("state")]), _vm._v("里。示例可以参考vux源码的"), _c('code', [_vm._v("App.vue")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("body-padding-top")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("主体的"), _c('code', [_vm._v("padding-top")]), _vm._v("值，当顶部存在"), _c('code', [_vm._v("x-header")]), _vm._v("等"), _c('code', [_vm._v("absolute")]), _vm._v("定位元素时需要设置")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("body-padding-bottom")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("主体的"), _c('code', [_vm._v("padding-bottom")]), _vm._v("值，当底部存在"), _c('code', [_vm._v("tabbar")]), _vm._v("等"), _c('code', [_vm._v("absolute")]), _vm._v("定位元素时需要设置")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("header")])]), _vm._v(" "), _c('td', [_vm._v("顶部区域，如果要使用统一的XHeader，可以使用该slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("主体内容，可滚动的区域")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("bottom")])]), _vm._v(" "), _c('td', [_vm._v("底部区域，Tabbar可以使用该slot")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("scrollTo")])]), _vm._v(" "), _c('td', [_c('code', [_vm._v("(top)")])]), _vm._v(" "), _c('td', [_vm._v("滚动到指定位置")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getScrollTop")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("获取当前滚动距离")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("getScrollBody")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("获取滚动"), _c('code', [_vm._v("div")]), _vm._v(", 也可以直接用组件引用的"), _c('code', [_vm._v(".$refs.viewBoxBody")])]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/view-box"
    }
  }, [_vm._v("Demo page")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', [_vm._v("XHeader_COM")]), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/components/x-header/metas.yml",
      "target": "_blank"
    }
  }, [_vm._v("编辑文档")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-header"
    }
  }, [_vm._v("进入demo页面")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vux.li/demos/v2/#/component/x-header",
      "target": "_blank"
    }
  }, [_vm._v("demo 原始链接")])]), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#999",
      "font-size": "12px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/blob/v2/src/demos/XHeader.vue",
      "target": "_blank"
    }
  }, [_vm._v("demo源码")])])]), _vm._v(" "), _c('pre', {
    staticClass: "hljs"
  }, [_c('code', [_c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("import")]), _vm._v(" { XHeader } "), _c('span', {
    staticClass: "hljs-keyword"
  }, [_vm._v("from")]), _vm._v(" "), _c('span', {
    staticClass: "hljs-string"
  }, [_vm._v("'vux'")]), _vm._v("\n")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Props")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("type")]), _vm._v(" "), _c('th', [_vm._v("default")]), _vm._v(" "), _c('th', [_vm._v("version")]), _vm._v(" "), _c('th', [_vm._v("description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.showBack")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("true")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否显示返回文字")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.backText")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("Back")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("返回文字")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left-options.preventGoBack")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否阻止返回")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("title")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("标题")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("transition")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-string"
  }, [_vm._v("String")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("标题出现的动画")])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right-options.showMore")])]), _vm._v(" "), _c('td', [_c('span', {
    staticClass: "type type-boolean"
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_vm._v("false")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })]), _vm._v(" "), _c('td', [_vm._v("是否显示右侧的更多图标")])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("default")])]), _vm._v(" "), _c('td', [_vm._v("标题")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("left")])]), _vm._v(" "), _c('td', [_vm._v("左侧部分插槽，在返回文字后，不会影响到原有的图标")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("overwrite-left")])]), _vm._v(" "), _c('td', [_vm._v("重写左侧部分的返回文字及图标")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.2.2")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("right")])]), _vm._v(" "), _c('td', [_vm._v("右侧部分插槽")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("overwrite-title")])]), _vm._v(" "), _c('td', [_vm._v("标题插槽，用于自定义标题位置内容")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("v2.5.3")])])])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "vux-props-title"
  }, [_vm._v("Events")])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("name")]), _vm._v(" "), _c('th', [_vm._v("params")]), _vm._v(" "), _c('th', [_vm._v("description")]), _vm._v(" "), _c('th', [_vm._v("version")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-more")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("点击右侧更多时触发")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-back")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("当left-options.preventGoBack为true,点击左边返回时触发")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('span', {
    staticClass: "prop-key",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("on-click-title")])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v("点击标题时触发")]), _vm._v(" "), _c('td', [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "white-space": "nowrap"
    }
  })])])])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "vux-demo-link",
    attrs: {
      "href": "#",
      "router-link": "/zh-CN/demos/x-header"
    }
  }, [_vm._v("Demo page")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1fdadbf0", module.exports)
  }
}

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2016);

/***/ })

});


// WEBPACK FOOTER //
// 581.1ff945b4.js